<template>
  <div>
   <div style="height: 100px;">
     <h4 style="text-align: center;color:#fff">欢迎进入，{{$store.state.userinfo.name}}</h4>

   </div>
   <div class="cardarea" >
       <div style="width: 96% height:30px;">
         <span style="margin-left: 25px;font-size: 16px;"><b>通用区域</b></span>
       </div>
       <van-grid :column-num="4" :border="false">
         <van-grid-item  text="产品库存" @click="torouter('/tongyong/sucailist')">
               <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
               <span style="font-size: 12px;">查看素材</span>
         </van-grid-item>
         <van-grid-item  text="创建订单" @click="torouter('/tongyong/sucaiupload')">
               <van-image src="../../static/img/createorder.png" style="width: 40px;height: 40px;"/>
               <span style="font-size: 12px;">上传素材</span>
         </van-grid-item>
       </van-grid>

   </div>

   <div class="cardarea" >
       <div style="width: 96% height:30px;">
         <span style="margin-left: 25px;font-size: 16px;"><b>销售区域</b></span>
       </div>
       <van-grid :column-num="4" :border="false">

         <van-grid-item  text="产品库存" @click="torouter('/salerviews/products')">
               <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
               <span style="font-size: 12px;">产品库存</span>
         </van-grid-item>

         <van-grid-item  text="创建订单" @click="torouter('/salerviews/ordercreate')">
               <van-image src="../../static/img/createorder.png" style="width: 40px;height: 40px;"/>
               <span style="font-size: 12px;">创建订单</span>
         </van-grid-item>
         <van-grid-item  text="我的订单" @click="torouter('/salerviews/myorder')">
               <van-image src="../../static/img/myorder.png" style="width: 40px;height: 40px;"/>
               <span style="font-size: 12px;">我的订单</span>
         </van-grid-item>
       </van-grid>

   </div>


  <div class="cardarea" v-if="$store.state.userinfo.iscangku">
      <div style="width: 96% height:30px;">
        <span style="margin-left: 25px;font-size: 16px;"><b>仓库区域</b></span>
      </div>
      <van-grid :column-num="4" :border="false">
        <van-grid-item  text="配送单" @click="torouter('/cangkuviews/sendorder')">
              <van-image src="../../static/img/peisong.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">配送单</span>
        </van-grid-item>

        <van-grid-item  text="配送单完成" @click="torouter('/cangkuviews/sendorderdone')">
              <van-image src="../../static/img/peisong.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">配送单(完成)</span>
        </van-grid-item>
      </van-grid>

  </div>


  <div class="cardarea"v-if="$store.state.userinfo.isshangwu" >
      <div style="width: 96% height:30px;">
        <span style="margin-left: 25px;font-size: 16px;"><b>商务区域</b></span>
      </div>
      <van-grid :column-num="4" :border="false">

        <van-grid-item  text="入库查询" @click="torouter('/shangwuviews/rukulist')">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">入库查询</span>
        </van-grid-item>
        <van-grid-item  text="入库新增" @click="torouter('/shangwuviews/rukuadd')">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">入库新增</span>
        </van-grid-item>
     <!--   <van-grid-item  text="调货处理" >
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">调货处理</span>
        </van-grid-item> -->

        <!-- <van-grid-item  text="退货查询">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">退货查询</span>
        </van-grid-item> -->
   <!--     <van-grid-item  text="退货新增">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">退货新增</span>
        </van-grid-item> -->
        <van-grid-item  text="客户查询" @click="torouter('/shangwuviews/clientview')">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">客户查询</span>
        </van-grid-item>
        <van-grid-item  text="客户新增" @click="torouter('/shangwuviews/clientadd')">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">客户新增</span>
        </van-grid-item>
        <van-grid-item  text="订单查询" @click="torouter('/shangwuviews/orders')">
              <van-image src="../../static/img/kucun.png" style="width: 40px;height: 40px;"/>
              <span style="font-size: 12px;">订单处理</span>
        </van-grid-item>
      </van-grid>

  </div>
  <!--  <div class="cardarea" v-if="!$store.state.userinfo.isshangwu">
          <div style="width: 96% height:30px;">
            <span style="margin-left: 25px;font-size: 16px;"><b>商务区域</b></span>
          </div>
          <van-grid :column-num="4" :border="false">
            <van-grid-item  text="添加客户" @click="torouter('/cangkuviews/sendorder')">
                  <van-image src="../../static/img/kehu.png" style="width: 40px;height: 40px;"/>
                  <span style="font-size: 12px;">添加客户</span>
            </van-grid-item>
            <van-grid-item icon="photo-o" text="查看订单" />
            <van-grid-item icon="photo-o" text="查看入库" />
            <van-grid-item icon="photo-o" text="查看出库" />
            <van-grid-item icon="photo-o" text="查看退货" />
            <van-grid-item icon="photo-o" text="业绩统计" />
          </van-grid>

      </div>
    <div class="cardarea" v-if="$store.state.userinfo.isadmin">
          <div style="width: 96% height:30px;margin-top: 5px;">
            <span style="margin-left: 25px;font-size: 16px;"><b>管理区域</b></span>
          </div>
         <van-grid :column-num="4" :border="false">
           <van-grid-item icon="photo-o" text="审批专区" />
           <van-grid-item icon="photo-o" text="查看审批" />
         </van-grid>

      </div> -->


  </div>
</template>

<script>
  import * as Api from './api.js'
  export default {
    name: 'Main',
    data () {
      return {
        code:'',
        userinfo:{},
        state:{},
      //   username:'SheJianHui',
       urlString:'',

      }
    },
    created() {
      this.getcodetologin()
    },
    methods:{
      getcodetologin(){
        this.urlString = window.location.href;
        if (this.urlString.includes('code')){
          this.query = this.urlString.split('?')[1]; // 获取URL中?后面的部分
          const paramArray = this.query.split('&');
          const params = {};
          paramArray.forEach((param) => {
            const [key, value] = param.split('=');
            params[key] = decodeURIComponent(value);
          });
          this.code = params.code; // 获取名为param1的参数值
          this.tologin()
        }else{
          this.$store.dispatch('getlocaluserinfo')
        }
      },
      tologin(){
        Api.login({code:this.code}).then(res=>{
         this.$store.commit('setuserinfo',res.data)
         localStorage.setItem('userinfo', JSON.stringify(res.data));
        })
      },
      getcode(){
         let url = window.location.href
         let b = new URL(url);
         let params = b.search.replace('?','').split('&')
         let code = params[0].split('=')
         this.code = code[1]
				 let state = params[1].split('=')
				 this.state = state[1]

      },
      torouter(url){
        this.$router.push({path:url})
      }


    }
  }

</script>

<style>

  .cardarea{
    width: 96%;

    min-height: 140px;
    background-color: #fff;
    margin: 0 auto;
    box-shadow:0 10px 10px 0 rgba(0,0,0,0.2);
    margin-bottom:25px; /* 底外边距 */
    border-radius:25px; /* 设置圆角 */
    -moz-border-radius:25px; /* 老版的Firefox浏览器 */
    padding: 20px 0px 20px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue